import React from 'react';
import PropTypes from 'prop-types';
import createEmotionStyled from 'create-emotion-styled';
import createEmotion from 'create-emotion';
var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = createEmotion(context, {
  nonce: btoa('web-ui-components')
}),
    caches = _createEmotion.caches,
    css = _createEmotion.css,
    cx = _createEmotion.cx,
    flush = _createEmotion.flush,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    hydrate = _createEmotion.hydrate,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    merge = _createEmotion.merge,
    sheet = _createEmotion.sheet;

var emotion = /*#__PURE__*/Object.freeze({
  __proto__: null,
  caches: caches,
  css: css,
  cx: cx,
  flush: flush,
  getRegisteredStyles: getRegisteredStyles,
  hydrate: hydrate,
  injectGlobal: injectGlobal,
  keyframes: keyframes,
  merge: merge,
  sheet: sheet
});
var styled = createEmotionStyled(emotion, React);
var theme = {
  baseFontSize: 16
}; //DEBTxCYBG pull this from theme component or global?

var baseSpacing = 8;

var spacing = function spacing(value) {
  var fontMultiple = value * baseSpacing;
  var rems = fontMultiple / theme.baseFontSize;
  return rems + "rem";
};

var componentMargin = "\n    margin-right: " + spacing(2) + "; \n    margin-bottom: " + spacing(2) + ";    \n";
var breakpoints = {
  xs1: '0',
  xs2: '480px',
  sm1: '540px',
  sm2: '640px',
  md1: '768px',
  md2: '960px',
  lg1: '1024px',
  lg2: '1280px',
  lg3: '1328px',
  xl1: '1420px',
  xl2: '1920px'
};
/* Font size config: usage example ${fontSize('arran')} */

var fontConfig = {
  lewis: {
    xs1: {
      fontSize: 37,
      lineHeight: 1.189
    },
    sm1: {
      fontSize: 37,
      lineHeight: 1.189
    },
    md1: {
      fontSize: 45,
      lineHeight: 1.067
    },
    lg1: {
      fontSize: 52,
      lineHeight: 1.154
    },
    xl1: {
      fontSize: 52,
      lineHeight: 1.154
    }
  },
  skye: {
    xs1: {
      fontSize: 32,
      lineHeight: 1.125
    },
    sm1: {
      fontSize: 32,
      lineHeight: 1.125
    },
    md1: {
      fontSize: 40,
      lineHeight: 1.1
    },
    lg1: {
      fontSize: 45,
      lineHeight: 1.156
    },
    xl1: {
      fontSize: 45,
      lineHeight: 1.156
    }
  },
  shetland: {
    xs1: {
      fontSize: 29,
      lineHeight: 1.241
    },
    sm1: {
      fontSize: 29,
      lineHeight: 1.241
    },
    md1: {
      fontSize: 34,
      lineHeight: 1.176
    },
    lg1: {
      fontSize: 39,
      lineHeight: 1.128
    },
    xl1: {
      fontSize: 39,
      lineHeight: 1.128
    }
  },
  mull: {
    xs1: {
      fontSize: 26,
      lineHeight: 1.231
    },
    sm1: {
      fontSize: 26,
      lineHeight: 1.231
    },
    md1: {
      fontSize: 29,
      lineHeight: 1.241
    },
    lg1: {
      fontSize: 33,
      lineHeight: 1.212
    },
    xl1: {
      fontSize: 33,
      lineHeight: 1.212
    }
  },
  islay: {
    xs1: {
      fontSize: 23,
      lineHeight: 1.217
    },
    sm1: {
      fontSize: 23,
      lineHeight: 1.217
    },
    md1: {
      fontSize: 25,
      lineHeight: 1.28
    },
    lg1: {
      fontSize: 28,
      lineHeight: 1.286
    },
    xl1: {
      fontSize: 28,
      lineHeight: 1.286
    }
  },
  orkney: {
    xs1: {
      fontSize: 20,
      lineHeight: 1.4
    },
    sm1: {
      fontSize: 20,
      lineHeight: 1.4
    },
    md1: {
      fontSize: 22,
      lineHeight: 1.273
    },
    lg1: {
      fontSize: 25,
      lineHeight: 1.28
    },
    xl1: {
      fontSize: 25,
      lineHeight: 1.28
    }
  },
  arran: {
    xs1: {
      fontSize: 18,
      lineHeight: 1.333
    },
    sm1: {
      fontSize: 18,
      lineHeight: 1.333
    },
    md1: {
      fontSize: 19,
      lineHeight: 1.474
    },
    lg1: {
      fontSize: 21,
      lineHeight: 1.333
    },
    xl1: {
      fontSize: 21,
      lineHeight: 1.333
    }
  },
  jura: {
    xs1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    sm1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    md1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    lg1: {
      fontSize: 18,
      lineHeight: 1.556
    },
    xl1: {
      fontSize: 18,
      lineHeight: 1.556
    }
  },
  uist: {
    xs1: {
      fontSize: 14,
      lineHeight: 1.429
    },
    sm1: {
      fontSize: 14,
      lineHeight: 1.429
    },
    md1: {
      fontSize: 14,
      lineHeight: 1.429
    },
    lg1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    xl1: {
      fontSize: 16,
      lineHeight: 1.5
    }
  },
  bute: {
    xs1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    sm1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    md1: {
      fontSize: 13,
      lineHeight: 1.538
    },
    lg1: {
      fontSize: 13,
      lineHeight: 1.538
    },
    xl1: {
      fontSize: 13,
      lineHeight: 1.538
    }
  },
  cumbrae: {
    xs1: {
      fontSize: 11,
      lineHeight: 1.455
    },
    sm1: {
      fontSize: 11,
      lineHeight: 1.455
    },
    md1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    lg1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    xl1: {
      fontSize: 12,
      lineHeight: 1.333
    }
  }
};

var generateSASS = function generateSASS(mqBreakpoint, size, lineHeight) {
  var styles = '';

  if (parseInt(mqBreakpoint) === 0) {
    styles = 'font-size: ' + size + 'px; line-height: ' + lineHeight + ';';
  } else {
    styles = '\n      @media (min-width: ' + mqBreakpoint + ') {\n        font-size: ' + size + 'px;\n        line-height: ' + lineHeight + ';\n      } \n    ';
  }

  return styles;
};

var fontSizes = {};

for (var _fontSize in fontConfig) {
  if (fontConfig.hasOwnProperty(_fontSize)) {
    var style = '';

    for (var breakpoint in fontConfig[_fontSize]) {
      if (fontConfig[_fontSize].hasOwnProperty(breakpoint)) {
        var _fontConfig$_fontSize = fontConfig[_fontSize][breakpoint],
            size = _fontConfig$_fontSize.fontSize,
            lineHeight = _fontConfig$_fontSize.lineHeight;
        style += generateSASS(breakpoints[breakpoint], size, lineHeight);
      }
    }

    fontSizes[_fontSize] = style;
  }
}

var fontSize = function fontSize(font) {
  return fontSizes[font];
};

var taggedTemplateLiteral = function taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var _templateObject = taggedTemplateLiteral(['\n\t', ' ', ';\n\t', ';\n'], ['\n\t', ' ', ';\n\t', ';\n']);

var getFontProperties = function getFontProperties(props) {
  var fontProperties = 'font-size: 16px; line-height: 1.5;'; // TODOxCYBG To be revisited with responsive VM typography.
  // if (props.theme.name !== 'vm') {

  fontProperties = props.theme.isCompact ? fontSize('bute') : fontSize('jura'); // }

  return fontProperties;
};

var StyledStandardBody = styled('div')(_templateObject, getFontProperties, function (props) {
  return !props.isFlush && 'margin-bottom: ' + spacing(2);
}, function (props) {
  return !props.isFlush && 'margin-right: ' + spacing(2);
});
/**
 * @example ./Design.md
 */

var StandardBody = function StandardBody(_ref) {
  var isFlush = _ref.isFlush,
      children = _ref.children;
  return React.createElement(StyledStandardBody, {
    isFlush: isFlush
  }, children);
};

StandardBody.propTypes = {
  /** Child content as node. Should be used to wrap bodies of textual content. This textual content
   * should contain appropriate HTML tagging and passing in orphan text child content should
   * be avoided. */
  children: PropTypes.node.isRequired,

  /** Removed margins. */
  isFlush: PropTypes.bool
};
StandardBody.defaultProps = {
  isFlush: false
};

StandardBody.defaultExample = function () {
  return React.createElement(StandardBody, null, React.createElement('p', null, 'StandardBody example'));
};

var _templateObject$1 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']),
    _templateObject2 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tpadding-top: ', ';\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tlist-style: none;\n'], ['\n\tcolor: ', ';\n\tpadding-top: ', ';\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tlist-style: none;\n']),
    _templateObject3 = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid black;\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n'], ['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid black;\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n']);

var StyledWrapper = styled('div')(_templateObject$1, componentMargin);
var StyledUL = styled('ul')(_templateObject2, function (props) {
  return props.theme.colours.bodyText;
}, function (props) {
  return props.level === 1 ? '1rem' : '0';
}, spacing(2));
var StyledListItem = styled('li')(_templateObject3, spacing(1), function (props) {
  return props.level % 2 > 0 ? 'black' : 'transparent';
}, function (props) {
  return props.level % 4 === 3 || props.level % 4 === 0 ? '0' : '100%';
});

var processItems = function processItems(items, level) {
  return React.createElement(StyledUL, {
    level: level
  }, items.map(function (item, index) {
    if (Array.isArray(item)) {
      var newLevel = level;
      newLevel += 1;
      return processItems(item, newLevel);
    }

    return React.createElement(StyledListItem, {
      key: level + '.' + [index],
      level: level
    }, React.createElement(StandardBody, {
      isFlush: true
    }, item));
  }));
};
/**
 * @example ./Design.md
 */


var BulletList = function BulletList(_ref) {
  var items = _ref.items;
  return React.createElement(StyledWrapper, null, processItems(items, 1));
};

BulletList.propTypes = {
  /** An array of strings for each item. Can include other arrays for sub items. */
  items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.string])).isRequired
};
BulletList.defaultProps = {};

BulletList.defaultExample = function () {
  return React.createElement(BulletList, {
    items: ['List item 1', 'List item 2', 'List item 3', 'List item 4']
  });
};

var _templateObject$2 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']),
    _templateObject2$1 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tpadding-top: ', ';\n\tpadding-left: ', ';\n\tmargin-left: ', ';\n\tlist-style-type: ', ';\n'], ['\n\tcolor: ', ';\n\tpadding-top: ', ';\n\tpadding-left: ', ';\n\tmargin-left: ', ';\n\tlist-style-type: ', ';\n']),
    _templateObject3$1 = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n\tmargin-left: ', ';\n\tpadding-left: ', ';\n\tposition: relative;\n'], ['\n\tmargin-bottom: ', ';\n\tmargin-left: ', ';\n\tpadding-left: ', ';\n\tposition: relative;\n']);

var StyledWrapper$1 = styled('div')(_templateObject$2, componentMargin);
var StyledOL = styled('ol')(_templateObject2$1, function (props) {
  return props.theme.colours.bodyText;
}, function (props) {
  return props.level === 1 ? '1rem' : '0';
}, function (props) {
  return props.level === 1 ? '0' : '1rem';
}, spacing(2), function (props) {
  if (props.level % 3 === 0) {
    return 'lower-roman';
  } else if (props.level % 3 === 2) {
    return 'lower-alpha';
  }

  return 'decimal';
});
var StyledListItem$1 = styled('li')(_templateObject3$1, spacing(1), spacing(2), spacing(1));

var processItems$1 = function processItems(items, level) {
  return React.createElement(StyledOL, {
    level: level
  }, items.map(function (item, index) {
    if (Array.isArray(item)) {
      var newLevel = level;
      newLevel += 1;
      return processItems(item, newLevel);
    }

    return React.createElement(StyledListItem$1, {
      key: level + '.' + [index],
      level: level
    }, React.createElement(StandardBody, {
      isFlush: true
    }, item));
  }));
};
/**
 * @example ./Design.md
 */


var NumberList = function NumberList(_ref) {
  var items = _ref.items;
  return React.createElement(StyledWrapper$1, null, processItems$1(items, 1));
};

NumberList.propTypes = {
  /** An array of strings for each item. Can include other arrays for sub items. */
  items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.string])).isRequired
};
NumberList.defaultProps = {};

NumberList.defaultExample = function () {
  return React.createElement(NumberList, {
    items: ['List item 1', 'List item 2', 'List item 3', 'List item 4']
  });
};

export { BulletList, NumberList };